import React, { useEffect } from 'react';
import { Typography, Button } from '@weirgroup/weir-dls';
import { CustomAlert } from '../../../../components/custom-alert';
import { useTranslation } from 'react-i18next';
import './confirmed-step.scss';
import { useAnalyticsEvent } from '../../../../hooks/useAnalyticsEvent';


interface FailedItem {
  serialNumber: string;
  error: any;
  asset: any;
}

interface ConfirmedStepProps {
  darkMode: boolean;
  successCount?: number;
  failCount?: number;
  failedItems?: FailedItem[];
  onFinish: () => void;
}

export const ConfirmedStep: React.FC<ConfirmedStepProps> = ({
  darkMode,
  successCount,
  failCount,
  failedItems = [],
  onFinish,
}) => {
  const { t } = useTranslation();
  const logAnalyticsEvent = useAnalyticsEvent();

  // Prepare separate messages for success and failure using translation
  useEffect(() => {
          logAnalyticsEvent('web_user_reached_confirmed_step', { description: 'User reached the confirmed step in upload assets' });
          console.log('Confirmed Step - Successes:', successCount, 'Failures:', failCount);
      },[]);
  return (
    <div className="confirmed-step-container">
      <Typography
        variant="H3"
        color={darkMode ? 'white' : 'black'}
        className="confirmed-title confirmed-title-centered"
      >
        {t('uploadAssets.steps.completed')}
      </Typography>
      <div className="confirmed-alert-section">
        {successCount && successCount > 0 && 
        (<CustomAlert
            type="success"
            message={`${t('uploadAssets.confirmedStep.successMessage', { count: successCount, plural: successCount })}`}
            darkMode={darkMode}
            className="confirmed-custom-alert"
          />)
        }
         {failCount && failCount > 0 && 
        (<CustomAlert
            type="error"
            message={`${t('uploadAssets.confirmedStep.failMessage', { count: failCount, plural: failCount })}`}
            darkMode={darkMode}
            className="confirmed-custom-alert"
          />)
        }
        {failedItems.length > 0 && (
          <div className="confirmed-failed-list">
            {failedItems.map((item, idx) => (
              <CustomAlert
                key={item.serialNumber || idx}
                type="error"
                message={
                  t('uploadAssets.confirmedStep.failedRowMessage', {
                    row: idx + 1,
                    serial: item.serialNumber || t('unknown', 'Unknown')
                  })
                }
                darkMode={darkMode}
                className="confirmed-custom-alert"
              />
            ))}
          </div>
        )}
      </div>
      <div className="confirmed-finish-btn-section">
        <Button
          darkMode={darkMode}
          label={t('uploadAssets.buttons.finish', 'Finish')}
          size="md"
          variant="primary"
          onClick={onFinish}
          className="confirmed-finish-btn"
        />
      </div>
    </div>
  );
};
